import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useCashFlow } from '../common/CashFlowContext';

export default function OnboardingScreen() {
  const { users, setCurrentUserId } = useCashFlow();

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', backgroundColor: '#F8F8F8', padding: 24,
    }}>
      <Typography.Title level={2} style={{ color: '#4A90D9' }}>가계부</Typography.Title>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 40 }}>
        본인을 선택해 주세요
      </Typography.Paragraph>
      <Space size="large" wrap style={{ justifyContent: 'center' }}>
        {users.map((u) => (
          <Card
            key={u.id}
            hoverable
            style={{ width: 180, textAlign: 'center' }}
            onClick={() => setCurrentUserId(u.id)}
          >
            <UserOutlined style={{ fontSize: 48, color: '#4A90D9' }} />
            <Typography.Title level={4} style={{ marginTop: 16 }}>
              {u.name}
            </Typography.Title>
            <Button type="primary" block>선택</Button>
          </Card>
        ))}
      </Space>
    </div>
  );
}
